<div class="row p-1 m-1">
  <div class="col-12 d-flex">
    <div class="px-1">1.</div>
    <div class="px-1">
      <div class="row pb-1">
        <div class="col-12">
          Name the President of United States?
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="d-flex  qt1-answer">
              <div class="p-0">
                <input type="radio" class="radiobtn" name="qta1"/>
              </div>
              <div class="p-0">
                <p class="m-0">Answer 1</p>
              </div>
            </div>   
        </div>
        <div class="col-12">
          <div class="d-flex  qt1-answer">
              <div class="p-0">
                <input type="radio" class="radiobtn" name="qta1"/>
              </div>
              <div class="p-0">
                <p class="m-0">Answer 1</p>
              </div>
            </div>   
        </div>
        <div class="col-12">
          <div class="d-flex  qt1-answer">
              <div class="p-0">
                <input type="radio" class="radiobtn" name="qta1"/>
              </div>
              <div class="p-0">
                <p class="m-0">Answer 1</p>
              </div>
            </div>   
        </div>
        <div class="col-12">
          <div class="d-flex  qt1-answer">
              <div class="p-0">
                <input type="radio" class="radiobtn" name="qta1"/>
              </div>
              <div class="p-0">
                <p class="m-0">Answer 1</p>
              </div>
            </div>   
        </div>
      </div>
    </div>
  </div>
</div>
